import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  participationButton: {
    color: theme.palette.baseColors.skyBlue.c100,
    paddingLeft: 0,
  },
}));
